<template>
	<div :class="'ideas-app-filter ' + (filter.terms.length > 10 ? 'scroll' : '')">
		<p>{{ filter.label }}</p>

		<form v-if="filter.terms.length > 10" @submit.prevent>
			<v-icon slug="magnifying-glass" />

			<input v-model="q" type="search" name="search" />
		</form>

		<div>
			<fieldset>
				<label
					v-for="term in terms"
					:key="term.value"
					:class="'checkbox ' + (selected_filters[slug].indexOf(term.value) > -1 ? 'checked' : '')"
				>
					<input
						v-model="selected_filters[slug]"
						type="checkbox"
						:name="slug"
						:value="term.value"
						@change="submit"
					/>
					<v-icon slug="check" />
					<span>{{ term.label }}</span>
				</label>
			</fieldset>
		</div>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';

import VIcon from '../jobs-app/_v-icon.vue';

const emit = defineEmits([`update`]);

const props = defineProps({
	slug: {
		type: String,
		required: true,
	},
	filter: {
		type: Object,
		required: true,
	},
	selected_filters: {
		type: Object,
		required: true,
	},
});

const q = ref(``);

const terms = computed(() => {
	if (q.value === ``) {
		return props.filter.terms;
	}

	const query = q.value.toLowerCase();

	return props.filter.terms.filter((term) => term.label.toLowerCase().indexOf(query) > -1);
});

function submit() {
	emit(`update`);
}
</script>
